import { NgModule } from '@angular/core';
import { RouterModule, provideRouter, withEnabledBlockingInitialNavigation } from '@angular/router';
import { MsalBroadcastService } from '@azure/msal-angular';
import { CoreEffects } from '@next/core-lib';
import { provideAgrCore } from '@next/core-lib/app';
import { I18nBrowserEffects } from '@next/core-lib/browser';
import { I18nEffects } from '@next/core-lib/i18n';
import { NavigationEffects, provideAgrNavigation } from '@next/core-lib/navigation';
import { provideAgrRouterStore } from '@next/core-lib/router-store';
import { provideAgrSettings } from '@next/core-lib/settings';
import { SiteEffects } from '@next/core-lib/site';
import { provideEffects } from '@ngrx/effects';
import { provideState, provideStore } from '@ngrx/store';

import { AppComponent } from './app.component';
import { appRoutes } from './app.routes';
import { AuthorizationsComponent } from './components/authorizations/authorizations.component';
import { SharedModule } from './shared/shared.module';
import { Effects } from './store/effects';
import { reducer } from './store/reducer';

@NgModule({
  declarations: [AppComponent, AuthorizationsComponent],
  imports: [RouterModule, SharedModule],
  providers: [
    MsalBroadcastService,
    provideRouter(appRoutes, withEnabledBlockingInitialNavigation()),
    provideStore(
      {},
      {
        runtimeChecks: {
          strictStateImmutability: true,
          strictActionImmutability: true,
          strictStateSerializability: true,
          strictActionSerializability: true,
        },
      },
    ),
    provideAgrRouterStore(),
    provideAgrCore(),
    provideAgrNavigation(),
    provideAgrSettings(),
    provideState('app', reducer),
    provideEffects([
      Effects,
      CoreEffects,
      I18nEffects,
      I18nBrowserEffects,
      SiteEffects,
      NavigationEffects,
    ]),
  ],
})
export class AppModule {}
